import {areSchemasEqual, createSchema,isSubset, Schema} from 'genson-js';
export function generateSchema(json:any) {
    return createSchema(json);
}
export type SchemaCompatibility = 'superset'|'subset'|'equal'|'unrelated' | 'noschema';
function tryParse(schema:string):Schema {
    try {
        return JSON.parse(schema) as Schema;
    } catch {
        return null;
    }
}
export function compareSchemas(os:string,ns:string):SchemaCompatibility {
    let oldSchema = tryParse(os);
    let newSchema = tryParse(ns);
    if (!newSchema) return 'noschema';
    if (!oldSchema) return 'unrelated';
 
    let result = areSchemasEqual(oldSchema,newSchema);
    if(result) {
        return 'equal';
    }
    result = isSubset(oldSchema,newSchema);
    if(result) {
        return 'subset';
    }
    result = isSubset(newSchema,oldSchema);
    if(result) {
        return 'superset';
    }
    return 'unrelated';
}
export function isSuperset(oldSchema: string, newSchema: string) {
    let o = JSON.parse(oldSchema) as Schema;
    let n = JSON.parse(newSchema) as Schema;
    return isSubset(o,n);
}



// export function isArraySuperset(expected, actual) {
//     for (let x of expected) {
//         if (actual.indexOf(x) == -1) {
//             return false;
//         }
//     }
//     return true;
// }
// // is actual a superset of expected
// function isSuperset(expected, actual, errors) {
//     if (!errors) errors = [];
//     if (expected.type != actual.type) return false;
//     if (expected.type == 'object') {
//         if (!isArraySuperset(expected.required, actual.required)) {
//             errors.push(`Expected ${JSON.stringify(expected.required)} but got ${JSON.stringify(actual.required)}`);
//         } else {

//             for (let prop of expected.required) {
//                 let et = expected.properties[prop];
//                 let at = actual.properties[prop];
//                 isSuperset(et, at, errors);
//             }
//         }

//     }
//     if (expected.type == 'array') {
//         isSuperset(expected.items, actual.items, errors);
//     }
//     return errors.length == 0;
// }